export const CardTypeCodes = {
  UNDEFINED: 0,
  EMPLOYEE: 1,
  LOYALTY: 2,
  BUSINESS: 6
}